function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = [
    "quickFilterParser",
    "quickFilterFormatter",
    "debounceMs",
    "className"
];
import * as React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import { unstable_debounce as debounce } from '@mui/utils';
import composeClasses from '@mui/utils/composeClasses';
import { getDataGridUtilityClass } from "../../constants/index.js";
import { useGridApiContext } from "../../hooks/utils/useGridApiContext.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.js";
import { useGridSelector } from "../../hooks/utils/useGridSelector.js";
import { gridQuickFilterValuesSelector } from "../../hooks/features/filter/index.js";
import { isDeepEqual } from "../../utils/utils.js";
import { jsx as _jsx } from "react/jsx-runtime";
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            'toolbarQuickFilter'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
var GridToolbarQuickFilterRoot = styled(TextField, {
    name: 'MuiDataGrid',
    slot: 'ToolbarQuickFilter',
    overridesResolver: function(props, styles) {
        return styles.toolbarQuickFilter;
    }
})(function(param) {
    var theme = param.theme;
    return _define_property({
        width: 'auto',
        paddingBottom: theme.spacing(0.5),
        '& input': {
            marginLeft: theme.spacing(0.5)
        },
        '& .MuiInput-underline:before': {
            borderBottom: "1px solid ".concat((theme.vars || theme).palette.divider)
        }
    }, '& input[type="search"]::-webkit-search-decoration,\n  & input[type="search"]::-webkit-search-cancel-button,\n  & input[type="search"]::-webkit-search-results-button,\n  & input[type="search"]::-webkit-search-results-decoration', {
        /* clears the 'X' icon from Chrome */ display: 'none'
    });
});
var defaultSearchValueParser = function(searchText) {
    return searchText.split(' ').filter(function(word) {
        return word !== '';
    });
};
var defaultSearchValueFormatter = function(values) {
    return values.join(' ');
};
function GridToolbarQuickFilter(props) {
    var _rootProps_slotProps, _rootProps_slotProps1;
    var apiRef = useGridApiContext();
    var rootProps = useGridRootProps();
    var classes = useUtilityClasses(rootProps);
    var quickFilterValues = useGridSelector(apiRef, gridQuickFilterValuesSelector);
    var _props_quickFilterParser = props.quickFilterParser, quickFilterParser = _props_quickFilterParser === void 0 ? defaultSearchValueParser : _props_quickFilterParser, _props_quickFilterFormatter = props.quickFilterFormatter, quickFilterFormatter = _props_quickFilterFormatter === void 0 ? defaultSearchValueFormatter : _props_quickFilterFormatter, _props_debounceMs = props.debounceMs, debounceMs = _props_debounceMs === void 0 ? rootProps.filterDebounceMs : _props_debounceMs, className = props.className, other = _objectWithoutPropertiesLoose(props, _excluded);
    var _React_useState = _sliced_to_array(React.useState(function() {
        return quickFilterFormatter(quickFilterValues !== null && quickFilterValues !== void 0 ? quickFilterValues : []);
    }), 2), searchValue = _React_useState[0], setSearchValue = _React_useState[1];
    var prevQuickFilterValuesRef = React.useRef(quickFilterValues);
    React.useEffect(function() {
        if (!isDeepEqual(prevQuickFilterValuesRef.current, quickFilterValues)) {
            // The model of quick filter value has been updated
            prevQuickFilterValuesRef.current = quickFilterValues;
            // Update the input value if needed to match the new model
            setSearchValue(function(prevSearchValue) {
                return isDeepEqual(quickFilterParser(prevSearchValue), quickFilterValues) ? prevSearchValue : quickFilterFormatter(quickFilterValues !== null && quickFilterValues !== void 0 ? quickFilterValues : []);
            });
        }
    }, [
        quickFilterValues,
        quickFilterFormatter,
        quickFilterParser
    ]);
    var updateSearchValue = React.useCallback(function(newSearchValue) {
        var newQuickFilterValues = quickFilterParser(newSearchValue);
        prevQuickFilterValuesRef.current = newQuickFilterValues;
        apiRef.current.setQuickFilterValues(newQuickFilterValues);
    }, [
        apiRef,
        quickFilterParser
    ]);
    var debouncedUpdateSearchValue = React.useMemo(function() {
        return debounce(updateSearchValue, debounceMs);
    }, [
        updateSearchValue,
        debounceMs
    ]);
    React.useEffect(function() {
        return debouncedUpdateSearchValue.clear;
    }, [
        debouncedUpdateSearchValue
    ]);
    var handleSearchValueChange = React.useCallback(function(event) {
        var newSearchValue = event.target.value;
        setSearchValue(newSearchValue);
        debouncedUpdateSearchValue(newSearchValue);
    }, [
        debouncedUpdateSearchValue
    ]);
    var handleSearchReset = React.useCallback(function() {
        setSearchValue('');
        updateSearchValue('');
    }, [
        updateSearchValue
    ]);
    return /*#__PURE__*/ _jsx(GridToolbarQuickFilterRoot, _extends({
        as: rootProps.slots.baseTextField,
        ownerState: rootProps,
        variant: "standard",
        value: searchValue,
        onChange: handleSearchValueChange,
        className: clsx(classes.root, className),
        placeholder: apiRef.current.getLocaleText('toolbarQuickFilterPlaceholder'),
        "aria-label": apiRef.current.getLocaleText('toolbarQuickFilterLabel'),
        type: "search"
    }, other, {
        InputProps: _extends({
            startAdornment: /*#__PURE__*/ _jsx(rootProps.slots.quickFilterIcon, {
                fontSize: "small"
            }),
            endAdornment: /*#__PURE__*/ _jsx(rootProps.slots.baseIconButton, _extends({
                "aria-label": apiRef.current.getLocaleText('toolbarQuickFilterDeleteIconLabel'),
                size: "small",
                sx: [
                    searchValue ? {
                        visibility: 'visible'
                    } : {
                        visibility: 'hidden'
                    }
                ],
                onClick: handleSearchReset
            }, (_rootProps_slotProps = rootProps.slotProps) === null || _rootProps_slotProps === void 0 ? void 0 : _rootProps_slotProps.baseIconButton, {
                children: /*#__PURE__*/ _jsx(rootProps.slots.quickFilterClearIcon, {
                    fontSize: "small"
                })
            }))
        }, other.InputProps)
    }, (_rootProps_slotProps1 = rootProps.slotProps) === null || _rootProps_slotProps1 === void 0 ? void 0 : _rootProps_slotProps1.baseTextField));
}
process.env.NODE_ENV !== "production" ? GridToolbarQuickFilter.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The debounce time in milliseconds.
   * @default 150
   */ debounceMs: PropTypes.number,
    /**
   * Function responsible for formatting values of quick filter in a string when the model is modified
   * @param {any[]} values The new values passed to the quick filter model
   * @returns {string} The string to display in the text field
   * @default (values: string[]) => values.join(' ')
   */ quickFilterFormatter: PropTypes.func,
    /**
   * Function responsible for parsing text input in an array of independent values for quick filtering.
   * @param {string} input The value entered by the user
   * @returns {any[]} The array of value on which quick filter is applied
   * @default (searchText: string) => searchText
   *   .split(' ')
   *   .filter((word) => word !== '')
   */ quickFilterParser: PropTypes.func
} : void 0;
/**
 * Demos:
 * - [Filtering - overview](https://mui.com/x/react-data-grid/filtering/)
 * - [Filtering - quick filter](https://mui.com/x/react-data-grid/filtering/quick-filter/)
 *
 * API:
 * - [GridToolbarQuickFilter API](https://mui.com/x/api/data-grid/grid-toolbar-quick-filter/)
 */ export { GridToolbarQuickFilter };
